module.exports = __webpack_public_path__ + "img/chalkboard-laptop-isolated-vector-concept-online-traditional-education-educational-gra.bfcb074b.png";